import { ACTIONS, USERTYPES } from "../../../constants/Constants"

export const data = (state, checkFirm, userData, userType) => {
  console.log("In data --->",userData , userType)
    return (
        (state.action === ACTIONS.EDIT || state.action === ACTIONS.VIEW)
      ? {
          id:userData?.user?.id,
          firstName: userData?.user?.firstName,
          lastName: userData?.user?.lastName,
          email: userData?.user?.email,
          mobile: userData?.user?.mobile,
          username: userData?.user?.username,
          password: "password",
          confirmPassword: "password",
          active: userData?.user?.active,
          action: state.action,
          accountNonLocked: userData?.user?.accountNonLocked, 
          firmIdList: checkFirm,
          twoFactorEnabled: userData?.user?.twoFactorEnabled,
          countOfconnections: userData?.user?.countOfconnections,
          showRadiologistTime: userData?.user?.showRadiologistTime,
          showConfirmation: userData?.user?.showConfirmation,
          radiologistType: userData?.user?.radiologistType,
          showAllStudies: userData?.user?.showAllStudies,
          disableSubmit: userData?.user?.disableSubmit,
          sendAssignMail: userData?.user?.sendAssignMail,
          checkCapacityOnManualAssign: userData?.user?.checkCapacityOnManualAssign,
          onPayroll: userData?.user?.onPayroll,
          uploadStudy: userData?.user?.uploadStudy,
          qcRadiologist: userData?.user?.qcRadiologist,
          qcSupervisor: userData?.user?.qcSupervisor,
          keyImage:userData?.user?.keyImage,
          qcSaveReport:userData?.user?.qcSaveReport,
          capacity: userData?.user?.capacity,
          modalityWithSubModalityPreferences: userType===USERTYPES.RADIOLOGIST ? ((userData!==undefined && userData?.modalityWithSubModalityPreference!==undefined)? userData?.modalityWithSubModalityPreferences: [] ) : [],
          // modalityWithSubModalityPreferences:[{modalityId:1, modalityName:"DX",subModalities:[{id:2, serviceName:"sub mod 2",listNumber:1,modalityId:1, serviceCode:"BVCR"},{id:3, serviceName:"sub mod 3",listNumber:1,modalityId:1, serviceCode:"BVCR"}]},
          // {modalityId:2, modalityName:"CT",subModalities:[{id:1, serviceName:"sub mod 1",listNumber:2,modalityId:2, serviceCode:"BVCR"},{id:2, serviceName:"sub mod 2",listNumber:2,modalityId:2, serviceCode:"BVCR"}]}],
          signatureText: userData?.user?.signatureDto?.signatureText,
          isSignatureImageDeleted: null,
          signatureDto: {
            isSignatureImageDeleted: userData?.user?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl: userData?.user?.signatureDto?.signatureImageUrl,
            signatureImage: null,
          },
          signatureImage: null,
          code: userData?.user?.code,
          firmCode: userData?.firmCode,
          firmName: userData?.user?.userFirmDto?.name,
          pediatricSpecialist: userData?.user?.pediatricSpecialist,
          selectedPediatricModalityId: userData?.user?.selectedPediatricModalityId,
          technicianContactList : (userType===USERTYPES.FIRMTECHNICIAN || userType===USERTYPES.FIRMDOCTOR || userType===USERTYPES.FIRMADMIN) ? ((userData!==undefined && userData?.user?.technicianContactList!==undefined)? userData?.user?.technicianContactList: [] ) : [],
          // technicianContactList: userData?.technicianContactList
          enableTypistWorkflow: userData?.user?.enableTypistWorkflow,
          showWord: userData?.user?.showWord,
          enableLlmReport: userData?.user?.enableLlmReport,
          isPeerReviewAdmin:userData?.user?.peerReviewAdmin,
          isPeerReviewEvaluator:userData?.user?.peerReviewEvaluator,
          isPasswordResetAllowed:userData?.user?.passwordResetAllowed
          
        }
      : {
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          username: "",
          password: "",
          confirmPassword: "",
          active: true,
          action: state.action,
          firmIdList: checkFirm,
          showRadiologistTime: false,
          showConfirmation: true,
          radiologistType: 1,
          showAllStudies: true,
          disableSubmit: false,
          sendAssignMail: true,
          checkCapacityOnManualAssign: false,
          onPayroll: false,
          uploadStudy: false,
          qcRadiologist: false,
          qcSupervisor:false,
          keyImage:false,
          qcSaveReport:false,
          capacity: 10,
          isSignatureImageDeleted: null,
          signatureDto: {
            isSignatureImageDeleted: 0,
            signatureImageUrl: null,
            signatureImage: null,
          },
          modalityWithSubModalityPreference:[],
          signatureText: "",
          signatureImage: null,
          pediatricSpecialist: false,
          selectedPediatricModalityId: [],
          technicianContactList: [],
          enableTypistWorkflow: 0,
          showWord: false,
          accountNonLocked: true,
          twoFactorEnabled: false,
          enableLlmReport: false,
          isPeerReviewAdmin:userData?.user?.isPeerReviewAdmin,
          isPeerReviewEvaluator:userData?.user?.isPeerReviewEvaluator,
          isPasswordResetAllowed:userData?.user?.passwordResetAllowed

        }
    )
}

export const addTabStatusInitialValue = {
  tab1Status: { value: "Info", color: "#FF9900" },
  tab2Status: { value: "Info", color: "#FF9900" },
  tab3Status: { value: "Info", color: "#FF9900" },
  tab4Status: { value: "Info", color: "#FF9900" },
  tab5Status: { value: "Info", color: "#FF9900" },
  tab6Status: { value: "Info", color: "#FF9900" },
};

export const editTabStatusInitialValue = {
  tab1Status: { value: "Completed", color: "green" },
  tab2Status: { value: "Completed", color: "green" },
  tab3Status: { value: "Completed", color: "green" },
  tab4Status: { value: "Completed", color: "green" },
};

export const setInitialProfileData = (profileData) => {
   console.log(profileData)
  return ( {
        firstName: profileData?.firstName,
        lastName: profileData?.lastName,
        email: profileData?.email,
        mobile: profileData?.mobile,
        username: profileData?.username,
        password:"Admin@123",
        confirmPassword:"Admin@123",
        active: profileData?.active,
        showRadiologistTime: profileData?.showRadiologistTime,
        showConfirmation: profileData?.showConfirmation,
        sendAssignMail: profileData?.sendAssignMail,
        checkCapacityOnManualAssign: profileData?.checkCapacityOnManualAssign,
        signatureText: profileData?.signatureDto?.signatureText,
    signatureImage: null,
    signatureDto: {
      isSignatureImageDeleted: 0,
      signatureImage: null,
    },
    technicianContactList: profileData?.technicianContactList != null ? profileData?.technicianContactList: []

})
}